export default __webpack_public_path__ + "static/3-staff-5050bbecda228b3418205d31b9859197.jpg";